/**
 * Lead ops timeline — automated pricing / email activity for admin.
 */

import api from "../../../shared/api.jsx";

/**
 * @param {string} leadId
 * @param {{ sort?: 'asc'|'desc', limit?: number }} [options]
 * @returns {Promise<{ success: boolean, data?: { leadId: string, events: object[] } }>}
 */
export async function getLeadOpsTimeline(leadId, options = {}) {
  const params = new URLSearchParams();
  if (options.sort) {
    params.set("sort", options.sort);
  }
  if (options.limit != null) {
    params.set("limit", String(options.limit));
  }

  const query = params.toString();
  const path = `/leads/${leadId}/ops-timeline${query ? `?${query}` : ""}`;
  return api.get(path);
}
